<div class="home">
  <main class="home__main">

    @if (loading()) {
      <div class="home__state">Carregando dashboard...</div>
    } @else if (erro()) {
      <div class="home__alert">{{ erro() }}</div>
    } @else {

    <!-- Hero -->
    <section class="home__hero">
      <div class="home__hero-eyebrow">{{ hojeExtenso() }}</div>
      <h1 class="home__hero-title">
        {{ saudacao() }}, {{ usuario().nome }}.
      </h1>
      <p class="home__hero-sub">
        Voce tem <strong>{{ resumoHero() }}</strong>
      </p>

      <div class="home__hero-actions">
        <a class="btn btn--ghost" routerLink="/cupons">Ver todos os cupons</a>
        <a class="btn btn--ghost" routerLink="/conferencia">Conferencia</a>
        <a class="btn btn--primary" routerLink="/cupons/novo">+ Novo cupom</a>
      </div>
    </section>

    <!-- Filtro de periodo -->
    <section class="home__filtro">
      <label class="home__filtro-label">Periodo</label>
      <div class="home__filtro-fields">
        <input type="date" class="home__filtro-input" [(ngModel)]="filtroInicio" />
        <span class="home__filtro-sep">ate</span>
        <input type="date" class="home__filtro-input" [(ngModel)]="filtroFim" />
        <button class="btn btn--primary" (click)="aplicarFiltro()" [disabled]="!filtroInicio || !filtroFim">Filtrar</button>
        @if (filtroInicio || filtroFim) {
          <button class="btn btn--ghost" (click)="limparFiltro()">Limpar</button>
        }
      </div>
    </section>

    <!-- KPIs -->
    <section class="home__kpis">
      @for (k of kpis(); track k.label) {
        <div class="kpi">
          <div class="kpi__label">{{ k.label }}</div>
          <div class="kpi__value">{{ k.value }}</div>
          <div class="kpi__foot">
            <span class="kpi__hint">{{ k.hint }}</span>
            @if (k.delta) {
              <span
                class="kpi__delta"
                [class.kpi__delta--up]="k.delta.dir === 'up'"
                [class.kpi__delta--down]="k.delta.dir === 'down'"
                [class.kpi__delta--flat]="k.delta.dir === 'flat'">
                @switch (k.delta.dir) {
                  @case ('up')   { &uarr; }
                  @case ('down') { &darr; }
                  @default       { &middot; }
                }
                {{ k.delta.texto }}
              </span>
            }
          </div>
        </div>
      }
    </section>

    <!-- Cupons em destaque -->
    <section class="home__block">
      <div class="home__block-head">
        <h2 class="home__block-title">Cupons em destaque</h2>
        <a class="home__block-link" routerLink="/cupons">Ver todos &rarr;</a>
      </div>

      @if (destaques().length === 0) {
        <div class="home__state">Nenhum cupom ativo cadastrado.</div>
      } @else {
        <div class="home__cards">
          @for (c of destaques(); track c.nrSequencia) {
            <a class="card" [routerLink]="['/cupons', c.nrSequencia, 'editar']">
              <div class="card__head">
                <span class="card__code">{{ c.codCupom }}</span>
                <span
                  class="card__status"
                  [class.card__status--on]="c.ieSituacao === 'A'"
                  [class.card__status--off]="c.ieSituacao !== 'A'">
                  <span class="card__dot"></span>
                  {{ c.ieSituacao === 'A' ? 'Ativo' : 'Inativo' }}
                </span>
              </div>
              <p class="card__desc">{{ c.dsCupom }}</p>
              <div class="card__metrics">
                <div>
                  <div class="card__metric-label">Aplicacoes</div>
                  <div class="card__metric-value">{{ fmtN(c.totalUsos) }}</div>
                </div>
                <div>
                  <div class="card__metric-label">Descontado</div>
                  <div class="card__metric-value">{{ fmtR(c.totalDescontado) }}</div>
                </div>
              </div>
            </a>
          }
        </div>
      }
    </section>

    <!-- Atividade recente -->
    <section class="home__block">
      <div class="home__block-head">
        <h2 class="home__block-title">Atividade recente</h2>
      </div>

      @if (atividade().length === 0) {
        <div class="home__state">Nenhuma aplicacao registrada ainda.</div>
      } @else {
        <div class="home__table-wrap">
          <table class="home__table">
            <thead>
              <tr>
                <th>Quando</th>
                <th>Cupom</th>
                <th>Paciente</th>
                <th>Unidade</th>
                <th class="num">Valor</th>
                <th>Operador</th>
              </tr>
            </thead>
            <tbody>
              @for (a of atividade(); track $index) {
                <tr>
                  <td class="muted">{{ fmtData(a.dtUso) }}</td>
                  <td class="mono accent">{{ a.codCupom }}</td>
                  <td>{{ a.nmPaciente }}</td>
                  <td>{{ a.dsEstabelecimento }}</td>
                  <td class="num">{{ fmtR(a.vlDescontoAplicado) }}</td>
                  <td class="mono mini">{{ a.nmUsuario }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </section>

    }
  </main>
</div>
